// AYA PRO — Connexion (maquette Réf 1, adaptée : connexion par téléphone uniquement, choix CEO).
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, User, Lock, Eye, EyeOff, ChevronRight, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { AyaProLogo } from "@/components/pro/AyaProLogo";
import "./ayapro.css";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AyaProLoginPage() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [remember, setRemember] = useState(true);
  const [busy, setBusy] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await fetch(`${API}/api/ayapro/login`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone, password }),
      });
      const j = await r.json();
      if (!j.ok) {
        const msg = j.error === "account_locked" ? `Trop de tentatives — réessayez dans ${j.retry_minutes} min`
          : j.error === "account_not_activated" ? "Compte non activé — utilisez votre lien d'activation"
          : "Téléphone ou mot de passe incorrect";
        throw new Error(msg);
      }
      const store = remember ? localStorage : sessionStorage;
      store.setItem("aya_pro_token", j.token);
      store.setItem("aya_pro_account", JSON.stringify(j.account));
      toast.success(`Bienvenue ${j.account.business_name} !`);
      navigate("/pro/dashboard");
    } catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };

  return (
    <div className="ap-page" data-testid="ayapro-login-page">
      <div className="ap-wrap">
        <div className="ap-head">
          <button className="ap-back" onClick={() => navigate("/pro/bienvenue")} data-testid="ayapro-login-back"><ArrowLeft size={15} /> Retour</button>
          <AyaProLogo variant="onboarding" onLight />
          <span className="ap-lang">FR ▾</span>
        </div>
        <h1 className="ap-h1">Connexion à AYA PRO</h1>
        <p className="ap-sub">Accédez à votre espace professionnel. Gérez votre activité, vos services et vos clients en toute simplicité.</p>
        <img src="/aya/ayapro/storefront.jpg" alt="Boutique AYA PRO" className="ap-illu" />
        <form className="ap-card" onSubmit={login}>
          <label className="ap-label" style={{ marginTop: 0 }}>Téléphone</label>
          <div className="ap-field">
            <User size={16} color="#6B7280" />
            <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Ex : 07 07 07 07 07" inputMode="tel" autoComplete="tel" data-testid="ayapro-login-phone" />
          </div>
          <label className="ap-label">Mot de passe</label>
          <div className="ap-field">
            <Lock size={16} color="#6B7280" />
            <input type={show ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Votre mot de passe" autoComplete="current-password" data-testid="ayapro-login-password" />
            <button type="button" className="ap-eye" onClick={() => setShow((s) => !s)} aria-label="Afficher le mot de passe" data-testid="ayapro-login-eye">{show ? <EyeOff size={17} /> : <Eye size={17} />}</button>
          </div>
          <div className="ap-row">
            <label className="ap-check">
              <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} data-testid="ayapro-login-remember" /> Se souvenir de moi
            </label>
            <button type="button" className="ap-link" onClick={() => toast.info("Réinitialisation bientôt disponible — contactez le support AYA")} data-testid="ayapro-login-forgot">Mot de passe oublié ?</button>
          </div>
          <button type="submit" className="ap-cta" disabled={busy || !phone.trim() || !password} data-testid="ayapro-login-submit">
            {busy ? "Connexion…" : "Se connecter"} <ChevronRight size={17} />
          </button>
        </form>
        <div className="ap-bottom">
          <span className="ic"><UserPlus size={19} /></span>
          <div>
            <h4>Pas encore de compte pro ?</h4>
            <p>Rejoignez AYA PRO et développez votre activité.</p>
          </div>
          <button className="go" onClick={() => navigate("/pro/inscription")} data-testid="ayapro-login-create">Créer un compte pro <ChevronRight size={13} /></button>
        </div>
      </div>
    </div>
  );
}
